import { Inbox, RefreshCw } from 'lucide-react'

import { Button } from '@/components/common/Button/Button'
import { cn } from '@/utils/cn'

import type { EmptyStateProps } from '../DataTable.types'

export const TableEmpty: React.FC<EmptyStateProps> = ({
  icon,
  title = 'No hay datos',
  description = 'No se encontraron registros para mostrar',
  action,
  onReset
}) => {
  const Icon = icon || <Inbox className="h-12 w-12 text-muted-foreground" />

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="mb-4">{Icon}</div>

      <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>

      <p className="text-muted-foreground text-center mb-8 max-w-sm leading-relaxed">
        {description}
      </p>

      {(action || onReset) && (
        <div className="flex flex-col gap-3 sm:flex-row">
          {onReset && (
            <Button
              variant="secondary"
              onClick={onReset}
              leftIcon={<RefreshCw className="h-4 w-4" />}
            >
              Limpiar filtros
            </Button>
          )}
          {action}
        </div>
      )}
    </div>
  )
}

// Specialized empty states
export const NoDataEmpty: React.FC<Omit<EmptyStateProps, 'icon' | 'title'>> = (props) => (
  <TableEmpty
    {...props}
    icon={<Inbox className="h-12 w-12 text-muted-foreground" />}
    title="Sin datos"
  />
)

export const NoResultsEmpty: React.FC<Omit<EmptyStateProps, 'icon' | 'title' | 'description'>> = (
  props
) => (
  <TableEmpty
    {...props}
    icon={<Inbox className="h-12 w-12 text-muted-foreground" />}
    title="No se encontraron resultados"
    description="Intenta ajustar los filtros o términos de búsqueda"
  />
)

// Loading skeleton for empty state
export const EmptyStateSkeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn('flex flex-col items-center justify-center py-16 px-4', className)}>
    <div className="h-12 w-12 bg-muted rounded-full mb-4 animate-pulse" />
    <div className="h-6 w-32 bg-muted rounded mb-2 animate-pulse" />
    <div className="h-4 w-48 bg-muted rounded mb-8 animate-pulse" />
    <div className="h-9 w-24 bg-muted rounded animate-pulse" />
  </div>
)
